enum VIDEO_TUTORIALS_MODAL_MODE {
  ALL = 'all',
  SINGLE = 'single',
}

export default VIDEO_TUTORIALS_MODAL_MODE;
